import React, { useCallback, useEffect, useState } from 'react';
import { Frame } from '@shopify/polaris';
import RouterContainer from './RouterContainer';
import AlertToast from '../../helpers/alertToast';
import { MainNavigation } from '../UI/Common/MainNavigation';
import { MainTopBar } from '../UI/Common/MainTopBar';

const NAV_COLLAPSED_KEY = 'mirtomex.nav.collapsed';
const readCollapsed = () => {
  try {
    return window.localStorage.getItem(NAV_COLLAPSED_KEY) === 'true';
  } catch (_) {
    return false;
  }
};

const AppFrame = () => {
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);

  // Menú lateral plegado a una tira de iconos (solo escritorio; en móvil el
  // menú de Polaris es un cajón y esto no aplica). Se recuerda por navegador.
  const [navCollapsed, setNavCollapsed] = useState(readCollapsed);
  const toggleNavCollapsed = useCallback(() => setNavCollapsed((v) => !v), []);
  useEffect(() => {
    try {
      window.localStorage.setItem(NAV_COLLAPSED_KEY, String(navCollapsed));
    } catch (_) {
      /* sin localStorage: queda en memoria */
    }
  }, [navCollapsed]);

  const toggleMobileNavigationActive = useCallback(
    () => setMobileNavigationActive((mobileNavigationActive) => !mobileNavigationActive),
    [],
  );

  const logo = {
    width: 124,
    topBarSource: '/mirtomex_logo.png',
    url: '/dashboard',
    accessibilityLabel: 'MIRTOMEX',
  };

  return (
    // Envoltorio solo para colgar la clase de plegado: el Frame de Polaris
    // no acepta `className`. Los estilos viven en App.css.
    <div className={navCollapsed ? 'mx-nav-collapsed' : undefined}>
      <Frame
        logo={logo}
        topBar={<MainTopBar toggleMobileNavigationActive={toggleMobileNavigationActive} />}
        showMobileNavigation={mobileNavigationActive}
        onNavigationDismiss={toggleMobileNavigationActive}
        navigation={<MainNavigation collapsed={navCollapsed} onToggleCollapsed={toggleNavCollapsed} />}
      >
        <div className="max-sm:mx-4">
          <RouterContainer />
          <AlertToast />
        </div>
      </Frame>
    </div>
  );
};
export default AppFrame;
